import { type Static, Type } from '@sinclair/typebox';
import { MongooseObjectIdOrStringSchema } from './common.dto.js';
import { StripePriceDTOSchema } from './stripe.dto.js';

export type TierState = 'draft' | 'published';

export const TIER_MAX_ITEMS = 8;
export const TierDTOSchema = Type.Object({
  _id: MongooseObjectIdOrStringSchema,
  amount: Type.Number({ minimum: 1, maximum: 1000 }),
  benefits: Type.Array(Type.String(), { minItems: 1, maxItems: TIER_MAX_ITEMS }),
  description: Type.String(),
  stripePrice: StripePriceDTOSchema,
  state: Type.Union([Type.Literal('draft'), Type.Literal('published')]),
  nbOfSubscribers: Type.Optional(Type.Number()),
  title: Type.String(),
});

export type TierDTO = Static<typeof TierDTOSchema>;
